import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './helpconnect.css';
import { HelpConnectAuthProvider, HcProtected, HcPublicOnly } from './HelpConnectAuth';
import HcLoginPage from './HcLoginPage';
import { HcSetPasswordPage, HcForgotPasswordPage } from './HcPasswordPages';
import HcDashboardPage from './HcDashboardPage';
import HcCoursesPage from './HcCoursesPage';
import HcCoursePlayerPage from './HcCoursePlayerPage';
import HcMessagesPage from './HcMessagesPage';
import HcCertificatesPage from './HcCertificatesPage';
import HcCalendarPage from './HcCalendarPage';
import HcResourcesPage from './HcResourcesPage';
import HcSupportPage from './HcSupportPage';
import { HcViewAsBanner } from './HcViewAsBanner';
import HcSupportiveServicePage from './HcSupportiveServicePage';

export default function HelpConnectApp() {
  useEffect(() => {
    const previous = document.title;
    document.title = 'HELPConnect | The HELP Center';
    return () => { document.title = previous; };
  }, []);
  return (
    <HelpConnectAuthProvider>
      <HcViewAsBanner />
      <Routes>
        <Route path="login" element={<HcPublicOnly><HcLoginPage /></HcPublicOnly>} />
        <Route path="forgot-password" element={<HcPublicOnly><HcForgotPasswordPage /></HcPublicOnly>} />
        <Route path="setup" element={<HcSetPasswordPage mode="setup" />} />
        <Route path="reset-password" element={<HcSetPasswordPage mode="reset" />} />
        <Route index element={<HcProtected><HcDashboardPage /></HcProtected>} />
        <Route path="courses" element={<HcProtected><HcCoursesPage /></HcProtected>} />
        <Route path="courses/:courseId" element={<HcProtected><HcCoursePlayerPage /></HcProtected>} />
        <Route path="courses/:courseId/lessons/:lessonId" element={<HcProtected><HcCoursePlayerPage /></HcProtected>} />
        <Route path="messages" element={<HcProtected><HcMessagesPage /></HcProtected>} />
        <Route path="certificates" element={<HcProtected><HcCertificatesPage /></HcProtected>} />
        <Route path="calendar" element={<HcProtected><HcCalendarPage /></HcProtected>} />
        <Route path="resources" element={<HcProtected><HcResourcesPage /></HcProtected>} />
        <Route path="resources/supportive-service-request" element={<HcProtected><HcSupportiveServicePage /></HcProtected>} />
        <Route path="support" element={<HcProtected><HcSupportPage /></HcProtected>} />
        <Route path="*" element={<Navigate to="/helpconnect" replace />} />
      </Routes>
    </HelpConnectAuthProvider>
  );
}
